module.exports = __webpack_public_path__ + "static/media/DaciaSpirit-Light_V1000.1e871ccc.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/spirit/DaciaSpirit-Light_V1000.woff
// module id = 654
// module chunks = 0